import SegmentComparison from './segmentComparison'
export default SegmentComparison
